export default __webpack_public_path__ + "static/media/physiotherapist.ad07ccf7.svg";